import { useTranslation } from "@coworker/locales";
import { useCustomAllSelectOption } from "../../shared/filters/utils/useAllSelectOption";
import {
  FilterType,
  FilterValue,
  InputType,
  SelectFilter,
  StringFilterValue,
} from "../../shared/filters/types/filter";
import { TASK_TYPE_ID } from "./useTaskTypeFilter";
import { useMemo } from "react";

const QUANTITY_TYPE_ID = "quantityType";

export function useQuantityTypeFilter(
  filterValues: FilterValue[]
): SelectFilter {
  const { t } = useTranslation();
  const defaultValue = { filterId: QUANTITY_TYPE_ID, value: "" };

  const enabled = useMemo(() => {
    const taskTypeValue = filterValues?.find(
      ({ filterId }) => filterId === TASK_TYPE_ID
    );
    const taskTypeValueValue =
      (taskTypeValue as StringFilterValue)?.value ?? "";
    return ["pickAndRefill", "refill"].includes(taskTypeValueValue);
  }, [filterValues]);

  return useCustomAllSelectOption(
    {
      inputType: InputType.Select,
      filterType: FilterType.Filter,
      id: QUANTITY_TYPE_ID,
      title: t("quantity_typeString"),
      options: [
        {
          value: "PIECES",
          title: t("piecesString"),
          dependsOnFilterId: TASK_TYPE_ID,
        },
        {
          value: "MULTI_PACK",
          title: t("multipackString"),
          dependsOnFilterId: TASK_TYPE_ID,
        },
        {
          value: "PALLET",
          title: t("palletString"),
          dependsOnFilterId: TASK_TYPE_ID,
        },
      ],
      enabled,
      defaultValue,
    },
    t("allQuantityTypesString")
  );
}
